import { render, staticRenderFns } from "./OptnEdit.vue?vue&type=template&id=03a57c70&scoped=true&"
import script from "./OptnEdit.vue?vue&type=script&lang=js&"
export * from "./OptnEdit.vue?vue&type=script&lang=js&"
import style0 from "./OptnEdit.vue?vue&type=style&index=0&id=03a57c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a57c70",
  null
  
)

export default component.exports